import { useEffect, useMemo, useState } from "react";
import ModalElement from "../../../Common/ModalElement"
import InputElement from "../../../Common/InputElement";
import ButtonElement from "../../../Common/ButtonElement";
import { validateFields, commonOnChange, copyToClipboard, shortenUrl } from "../../../utils";
import { useApiRequest } from "../../../hooks/useApiRequest";
import { appApis } from "../../../constants";
import { shallowEqual, useSelector } from "react-redux";

const channels = ["WhatsApp", "Email"]
const Reminder = ({ show, hideModal, extraDetails }) => {
    const [details, setDetails] = useState({
        channel: channels[0],
        message: "",
        messageErr: ""
    });

    const { message, messageErr, channel } = details;
    const { request, loading } = useApiRequest();
    const { companies, filters } = useSelector(state => ({
        companies: state.companies.companies ?? [],
        filters: state.inventory.filters ?? {}
    }), shallowEqual);
    const mobileNo = extraDetails?.mobileno ?? "";
    const companyData = useMemo(() => companies?.find(company => company?.companyId == extraDetails?.companyid), [extraDetails]);

    const onChangeHandler = (event) => commonOnChange(event, setDetails);

    const submit = () => {
        validateFields({ messageErr: [message, "text"] }, setDetails, () => {
            if (channel == "WhatsApp") whatsappAction();
            else emailAction();
        })
    }

    const emailAction = () => {
        const payload = { message, channel, invoiceId: extraDetails?.invoiceid }
        request({
            url: appApis.sendReminder,
            method: "POST",
            body: payload,
            onSuccess: () => setTimeout(hideModal, 400)
        })
    }

    const whatsappAction = () => {
        const webUrl = `https://wa.me/91${mobileNo}?text=${encodeURIComponent(message)}`;
        copyToClipboard(message);
        setTimeout(() => {
            window.open(webUrl, "_blank");
            hideModal();
        }, 1000);
    }

    const getTemplate = async () => {
        if (extraDetails?.invoicenumber) {
            const url = await shortenUrl(extraDetails?.invoice_url || "");
            const bussinessName = filters?.billingCompanies?.find(billComp => billComp?.id == extraDetails?.vehiclelist?.[0]?.billing_company_id)?.name ?? "";
            const requestBody = {
                templateType: 'Reminder',
                channel: 'WhatsApp',
                replacements: JSON.stringify({
                    "customer_name": extraDetails?.companyname ?? "",
                    "invoice_number": extraDetails?.invoicenumber ?? "",
                    "amount_due": extraDetails?.remainingamount ?? "",
                    "due_date": extraDetails?.invoicedate ?? "",
                    "company_name": bussinessName,
                    "invoice_url": url ? `\n\nYou can view or download your invoice here: ${url}` : ""
                })
            }
            request({
                showToast: false,
                url: appApis.reminder,
                config: { params: requestBody },
                onSuccess: (responseData) => {
                    const msg = responseData?.data?.formattedTemplate?.message || "";
                    setDetails(prev => ({ ...prev, message: msg, messageErr: !msg }));
                }
            })
        }
    }

    useEffect(() => {
        getTemplate();
    }, [])

    return <ModalElement size="lg" show={show} title={"Send Payment Reminder"} onHide={hideModal}>
        <div className="d-flex justify-content-between align-items-center mb-2">
            <h5 className="mb-2">{`Send a payment reminder to ${companyData?.name ?? ""}.`}</h5>
        </div>
        <div className="text-start">
            <div className="row">
                {/* <div className="tabs p-1 rounded d-md-flex justify-content-between text-center">
                    {channels.map((tab, index) => <div className={`d-flex justify-content-center align-items-center rounded py-2 flex-fill ${channel == tab ? "active" : ""} mx-1`} key={index} onClick={() => setDetails(prev => ({ ...prev, channel: tab }))}><div className="ms-2">{tab}</div>
                    </div>)}
                </div> */}
                <div className="recipient-section my-2">
                    <p className="input-label mb-0">Recipient</p>
                    <p className="text-muted mb-0">{channel == "WhatsApp" ? `+91 ${mobileNo}`: companyData?.email}</p>
                </div>
                <div className="col-12 mb-2">
                    <InputElement
                        disable={message?.length > 0}
                        isTextArea={true}
                        textRows="5"
                        label={"Message"}
                        placeholder={"Message for whatsapp"}
                        name={"message"}
                        value={message}
                        error={messageErr}
                        onChange={onChangeHandler}
                    />
                </div>
            </div>
        </div>
        <div className="submit-btn text-center my-3">
            <ButtonElement text={"Send Reminder"} cssClass="small-radius mb-1" onClick={submit} variant="btn-outline-primary" loading={loading} />
        </div>
    </ModalElement>
}

export default Reminder;